import React, { useState } from 'react';

const PasswordInput = ({ style, wrapperStyle, ...props }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ position: 'relative', ...wrapperStyle }}>
      <input
        {...props}
        type={visible ? 'text' : 'password'}
        style={{ ...style, paddingRight: '2.5rem', boxSizing: 'border-box' }}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible(v => !v)}
        title={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        style={{
          position: 'absolute', right: '0.65rem', top: '50%', transform: 'translateY(-50%)',
          background: 'none', border: 'none', cursor: 'pointer', padding: '0.2rem',
          fontSize: '1rem', lineHeight: 1, color: '#94a3b8', display: 'flex', alignItems: 'center',
        }}
      >
        {visible ? '🙈' : '👁️'}
      </button>
    </div>
  );
};

export default PasswordInput;
